
<template>
  <a-drawer
    title=""
    :width="480"
    placement="right"
    :visible="visible"
    @close="onClose(false)">
    <a-spin
      :spinning="fetching">
      <div class="row">
        <div class="col-md-12">
          <h3>Mass Upload Products</h3>
        </div>
      </div>

      <base-alert v-if="errMsgs.length" type="danger">
        <b>You have the following error(s):</b>
        <li v-for="error in errMsgs" :key="error">{{ error }}</li>
      </base-alert>

      <div>
        

        <label>
          Upload Mode:
          <a-select
            v-model="uploadMode"
            style="width: 120px">
            <a-select-option value="1">
              S3
            </a-select-option>
          </a-select>
        </label>

        <br><br>

        <a-upload-dragger
          :before-upload="beforeUpload"
          :remove="handleRemove"
          :fileList="fileList"
          :multiple="false" accept=".csv, .CSV">
          <span class="fa fa-file-import" style="font: 20pt;" />
          <p class="ant-upload-text">Click or drag file to this area to upload</p>
          <p class="ant-upload-hint">
            <ul style="text-align: left">
              <li style="text-align: left; color: red;">
                Please check the file before uploading and make sure that the values are correct. You are only allowed to upload once.
              </li>
              <li style="text-align: left">
                Products will be added through a background process after saving the promotion.
              </li>
              <li style="text-align: left">
                The headers of the uploading file must be {{ [this.searchVia, ...this.fileHeaders].join(", ") }}.
              </li>
              <li style="text-align: left">
                Kindly check if there are duplicate {{ searchVia }} in the uploading file.
              </li>
            </ul>

          </p>
          <p class="ant-upload-hint" v-if="false">
            Upload your product list in a CSV file following the specified format.
            Please upload maximum of {{ maxLines }} lines per batch.
          </p>
        </a-upload-dragger>

        <br><br>

        <a-collapse>
          <a-collapse-panel header="Downloadable Template" key="1">
          <a-list bordered>
              <a-list-item>
              <a-list-item-meta description="Contains required data to create a document">
                <a @click.prevent="downloadTemplate" slot="title">
                  Download Promotion Upload Products Template
                </a>
              </a-list-item-meta>
              <div>
                <a @click.prevent="downloadTemplate"><span class="fa fa-file-download"/></a></div>
              </a-list-item>
          </a-list>
          </a-collapse-panel>
        </a-collapse>
      </div>
    </a-spin>

    <div
      style="
        position: absolute;
        bottom: 0px;
        right: 0px;
        width: -webkit-fill-available;
        background-color: #f2f2f2;
        padding: 10px;
      "
    >
      <button
        class="btn btn-sm btn-primary float-right"
        style="width: 30%"
        @click.prevent="uploadProducts"
      >
        Upload
      </button>
      <button
        class="btn btn-sm btn-primary float-right"
        style="
          background-color: #394a5d;
          color: white;
          width: 30%;
          margin-right: 5%;
        "
        @click.prevent="onClose(false)"
      >
        Cancel
      </button>
    </div>
  </a-drawer>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import HTTPRequest from '../../../controllers/httpRequest.js';
import secureStorage from '../../../controllers/secureStorage.js';

export default {
  props: {
    promotionId: { type: Number },
    visible: { type: Boolean },
    onClose: { type: Function },
    selectedProducts: { type: Array },
    addProducts: { type: Function },
    promoType: { type: String },
    rewardType: { type: String },
    includeItem: { type: String },
    coupleType: { type: String },
  },
  data() {
    return {
      fileHeaders: [],
      fetching: false,
      errMsgs: [],
      fileList: [],
      searchVia: "barcode",
      uploadMode: "1"
    }
  },
  mounted: function() {
    this.setFileHeaders();
  },
  watch: {
    promoType: function() {
      this.setFileHeaders();
    },
    rewardType: function() {
      this.setFileHeaders();
    },
    includeItem: function() {
      if (this.promoType == '1' && this.fileList.length > 0) {
        this.fileList = []
        this.$notification['error']({
          message: 'Upload product file was removed.',
          description: "Changing Included Items removes the attached CSV file. Uploading Product is available for 'Select Specific Items' option only."
        });
      }
    },
    coupleType: function() {
      if (this.promoType == '6' && this.rewardType == '2' && this.fileList.length > 0) {
        this.fileList = []
        this.$notification['error']({
          message: 'Upload product file was removed.',
          description: "Changing Pair Options removes the attached CSV file. Please reupload the appropriate CSV format."
        });
      }
    }
  },
  computed: {
    ...mapState(['endPoint']),
  },
  methods: {
    setFileHeaders() {
      this.fileHeaders = [];
      // Required
      if ((this.promoType == '2' && this.rewardType != '1') ||
          this.promoType == '3' || (this.promoType == '6' && this.rewardType != '3')) {
        this.fileHeaders.push('required')
      }

      // Discount
      if ((this.promoType != '6' && this.promoType != '7' && this.promoType != '3' &&
           this.promoType != '4' && this.promoType != '5') ||
          (this.promoType == '3' && this.rewardType == '1')) {
        this.fileHeaders.push('discount')
      }

      // Limit
      if ((this.promoType != '6' && this.promoType != '3' && this.promoType != '5') ||
          (this.promoType == '3' && this.rewardType == '1')){
        this.fileHeaders.push('limit')
      }

      // Round
      // if ((this.promoType != '6' && this.promoType != '3' && this.promoType != '5') ||
      //     (this.promoType == '3' && this.rewardType == '1')){
      //   this.fileHeaders.push('round')
      // }

      // mass level pricing scheme
      if(this.promoType == '4'){
        [1,2,3,4,5].forEach((item) => {
          this.fileHeaders.push('l' + item + 'qty')
          this.fileHeaders.push('l' + item + 'price')
        })
      }
    },
    templateFileName() {
      let fileName = 'Promotion_Upload_Products_Template.csv';

      // Set Template File Name
      if (this.promoType == '1') {
        fileName = 'Simple_Promotion_Upload_Products_Template.csv';
      } else if (this.promoType == '2') {
        fileName = 'Multilevel_Promotion_Upload_Products_Template.csv';
      } else if (this.promoType == '3') {
        let specialName = 'Buy_X_Take_Y';
        if (this.rewardType == '1') { specialName = 'Buy_X_Take_X' }
        fileName = `${specialName}_Promotion_Upload_Products_Template.csv`;
      } else if (this.promoType == '4') {
        fileName = 'Pricing_Schemes_Promotion_Upload_Products_Template.csv';
      } else if (this.promoType == '5') {
        fileName = 'Coupon_Promotion_Upload_Products_Template.csv';
      } else if (this.promoType == '6') {
        if (this.rewardType == '1') {
          fileName = 'Conditional_Buy_All_Get_X_Upload_Products_Template.csv';
        } else {
          if (this.coupleType == 1) {
            fileName = 'Conditional_Buy_Any_Get_Any_Higher_Lower_Upload_Products_Template.csv';
          } else if (this.coupleType == 2) {
            fileName = 'Conditional_Buy_Any_Get_Any_First_Second_Upload_Products_Template.csv';
          } else {
            fileName = 'Conditional_Buy_Any_Get_Any_Item_A_and_B_Upload_Products_Template.csv';
          }
        }
      }

      return fileName;
    },
    downloadTemplate() {
      const headers = this.fileHeaders.join(",");
      const url = `${this.endPoint}import_templates/promotion_mass_upload_product_file?promo_type=${this.promoType}&reward_type=${this.rewardType}&search_via=${this.searchVia}&additional_headers=${headers}&couple_type=${this.coupleType}`;

      axios({
        url:  url,
        method: 'GET',
        responseType: 'blob', // important
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")
        }
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        let fileName = this.templateFileName();
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        this.$notification['success']({
          message: 'Successful Download',
          description: "You have succesfully downloaded the template for document upload."
        });
      });
    },
    checkLine(line) {
      return line || '';
    },
    checkTemplate(lines) {
      const headers = lines[0];
      const requiredHeaders = [this.searchVia, ...this.fileHeaders].join(",");

      // Check if the header is not equal with the selected option of the dropdown
      if (this.promoType == '6' && this.rewardType == '2' && ![1, 2].includes(parseInt(this.coupleType))) {
        const promoHeaders = this.checkLine(lines[1]).split(",");

        if (`${promoHeaders[2]}`.toString().trim() != "item_type" ||
            !['barcode', 'stock_no'].includes(`${promoHeaders[0]}`.toString().trim())) {
          this.errMsgs.push(`Invalid template. Please download the appropriate template for this Promotion`);
        }
      } else if (!(this.promoType == '6' && this.rewardType == '1') &&
            headers != requiredHeaders) {
        // this.errMsgs.push(`Invalid template. File header must be: ${requiredHeaders.split(",").join(", ")}`);
      } else if (this.promoType == '6' && this.rewardType == '1') {
        const productsUniqueHeader = this.checkLine(lines[1]).split(",")[0];

        if (!['barcode', 'stock_no'].includes(`${productsUniqueHeader}`.toString().trim())) {
          this.errMsgs.push(`Invalid template. Please download the appropriate template for this Promotion`);
        }
      }
    },
    checkForDuplicateUniqueCodes(uniqueCodes, msg) {
      const arry = uniqueCodes;

      const toFindDuplicates = arry => arry.filter((code, indx) => arry.indexOf(code) !== indx)
      const duplicateElements = toFindDuplicates(arry);

      if (duplicateElements.length > 0 && msg) {
        this.errMsgs.push(`${msg}: ${duplicateElements.join(', ')}`)
      } else if (!(this.promoType == '3' && this.rewardType == '2') && duplicateElements.length > 0) {
        this.errMsgs.push(`Following are duplicate ${this.searchVia} in the uploading file: ${duplicateElements.join(', ')}`)
      }
    },
    beforeUpload(file) {
      this.errMsgs = [];
      this.fetching = true;
      const skippedValues = [null, undefined, '', 'Buy X', 'Take Y', 'Item X', 'Uploading Products', 'barcode', 'stock_no'];

      const reader = new FileReader();

      reader.onload = e => {
        const text = e.target.result;
        const lines = text.split(/[\r\n]+/g); // tolerate both Windows and Unix linebreaks
        let uniqueCodes = [];

        this.checkTemplate(lines);

        if (this.errMsgs.length > 0) { return; }

        if (this.promoType == '6' && this.rewardType == '1') {
          lines.map((line, indx) => {
            const lineArr = line.split(",");
            const specialTextIndexes = [0, 1];
            const code = lineArr[0] ? `${lineArr[0]}`.trim() : '';

            if (!specialTextIndexes.includes(indx) && code.length > 0) {
              uniqueCodes.push(lineArr[0]);
            }
          });

          if (uniqueCodes.length == 0) {
            this.errMsgs.push(`Uploading File has empty data.`);
          }
        } else if (this.promoType == '6' && this.rewardType == '2' && this.coupleType == '') {
          let uniqueCodesBonus = []
          lines.slice(2).map(line => {
            const lineArr = line.split(",");

            if (!skippedValues.includes(lineArr[0].trim())) {
              const itemType = `${lineArr[2]}`.toLowerCase();
              if (itemType == 'p') {
                uniqueCodes.push(lineArr[0])
              } else if (itemType == 'b') {
                uniqueCodesBonus.push(lineArr[0])
              } else {
                this.errMsgs.push(`Item type for ${this.searchVia} ${lineArr[0]} is invalid.`);
              }
            }
          });

          if (uniqueCodes.length == 0 && uniqueCodesBonus.length == 0) {
            this.errMsgs.push(`Uploading File has empty data.`);
          }

          this.checkForDuplicateUniqueCodes(uniqueCodes, `Following are duplicate ${this.searchVia} for Prerequisite Items in the uploading file`);
          this.checkForDuplicateUniqueCodes(uniqueCodesBonus, `Following are duplicate ${this.searchVia} for Bonus Items in the uploading file`);
        } else {
          lines.slice(1).map(line => {
            const lineArr = line.split(",");

            if (!skippedValues.includes(lineArr[0].trim())) {
              uniqueCodes.push(lineArr[0])
              // if (this.promoType == '1' && !(parseFloat(lineArr[1].trim()) > 0)) {
              //   this.errMsgs.push(`${this.searchVia} ${lineArr[0]} discount is invalid.`);
              // }
            }
          });

          if (uniqueCodes.length == 0) {
            this.errMsgs.push(`Uploading File has empty data.`);
          }

          if (this.errMsgs.length == 0 && uniqueCodes.length > 0) {
            // Checking if uploading products does not exist in the current promotion
            let existingUniqueCodes = '';
            if (this.searchVia == 'barcode') {
              const existingProducts = this.selectedProducts.filter(product => uniqueCodes.includes(product.barcode));
              existingUniqueCodes = existingProducts.map(product => product.barcode).join(', ');
            } else {
              const existingProducts = this.selectedProducts.filter(product => uniqueCodes.includes(product.stock_no));
              existingUniqueCodes = existingProducts.map(product => product.stock_no).join(', ');
            }

            // Return an error message
            if (existingUniqueCodes.length > 0) {
              this.errMsgs.push(`The following ${this.searchVia} are already included in the promotion: ${existingUniqueCodes}`)
            }
          }
        }

        if (this.errMsgs.length == 0) {
          this.checkForDuplicateUniqueCodes(uniqueCodes);
        }

        this.errMsgs.length == 0 ? this.fileList = [file] : this.fileList = []
      }

      reader.readAsText(file);
      this.fetching = false;
      return false;
    },
    uploadProducts: async function() {
      this.onClose(false);
      // Prompt success message
      this.$notification['success']({
        message: 'CSV is ready',
        description: "Products will be added through a background process after saving the promotion."
      });
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    removeFile() {
      this.fileList = []
    }
  }

}
</script>

<style scoped>

</style>
